import { STORE_SCAN_OCR_VALUE } from 'actions/Types';

/* eslint-disable import/prefer-default-export */
export const storeScanOCR = (values) => (dispatch) => {
  dispatch({
    type: STORE_SCAN_OCR_VALUE,
    payload: values,
  });
};
